module.exports = __webpack_public_path__ + "img/liveerr.b063e476.png";